import { Tooltip } from '@/components/primitives/Tooltip'

import { Row } from '../../Row'

import { useTexts } from '../useTexts'

interface Props {
  count: number
  onSelect: () => void
}

export function OrdersExecuted(props: Props) {
  const { count, onSelect } = props
  const texts = useTexts()

  return (
    <Tooltip
      textAlign="left"
      placement="right"
      title={texts.ordersExecuted}
      subtitle={texts.ordersExecutedTooltip}
    >
      <Row
        text={texts.ordersExecuted}
        value={count}
        onClick={onSelect}
        disabled={count === 0}
        testId="plan-summary-executed-orders"
      />
    </Tooltip>
  )
}
